import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import { useEffect, useState } from 'react';

export const useNextCookieState = (cookieName: string, defaultValue: string): [string, ReactStateSetter<string>] => {
    const [value, setValue] = useState(() => {
        const cookieValue: string | undefined = getCookie(cookieName);
        return cookieValue === undefined ? defaultValue : cookieValue;
    });

    useEffect(() => {
        const cookieValue: string | undefined = getCookie(cookieName) ?? defaultValue ?? '';

        setValue(cookieValue);
    }, [cookieName, defaultValue]);

    useEffect(() => {
        if (value) {
            setCookie(cookieName, value);
        } else {
            deleteCookie(cookieName);
        }
    }, [cookieName, value]);

    return [value, setValue];
};
